export default "__VITE_ASSET__bf936d24__"